import React from "react";
import Goluzdravac from "../../assets/img/goluzdravac.png";
import Cucavac from "../../assets/img/cucavac.png";
import Ciopa from "../../assets/img/crna-ciopa.png";
import Poletarac from "../../assets/img/poletarac.png";


import "./Options.css";

const ReachOptions = (props) => {
  const simpleOptions = [
    {
      text: "Goluždravac",
      handler: props.actionProvider.handleGoluzdravac,
      img: Goluzdravac,
      id: 1,
    },
    { 
      text: "Čučavac",
      handler: props.actionProvider.handleCucavac,
      img: Cucavac,
      id: 2,
    },
    { 
      text: "Poletarac", 
      handler: props.actionProvider.handlePoletarac,
      img: Poletarac,
      id: 3
    },
    { 
      text: "Crna čiopa", 
      handler: props.actionProvider.handleCiopa,
      img: Ciopa,
      id: 4
    }
  ];

  const buttonsMarkup = simpleOptions.map((option) => (
    <button key={option.id} onClick={option.handler} className="option-button">
      <img src={option.img?option.img:Goluzdravac} className="option-img" alt=""></img>
    </button>
  ));

  return <div className="options-container">{buttonsMarkup}</div>;
};

export default ReachOptions;
